import { Component, OnInit } from '@angular/core';
import { AppContainerOptions, AppContainerService, IAppContainerFrame } from '@mydocma/app-container';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  providers: [],
})
export class MainComponent implements OnInit, IAppContainerFrame {

  constructor(
    public options: AppContainerOptions,
    private appContainerService: AppContainerService,
  ) {
    this.appContainerService.notifyChanges((appcontainer) => {
      appcontainer.appIcon.name = environment.appName;
      appcontainer.appIcon.color = environment.appIconColor;

    });
  }

  acOnRegister(appContainer: AppContainerOptions) {
    // buttons.push(new LinkSideNavButton({id: 'pix3', text: 'Help', url: '/pix/help'}));
    // appContainer.sideNavBar.buttons = buttons;
  }

  acOnUnregister(appContainer: AppContainerOptions) {
    appContainer.sideNavBar.buttons = [];
    appContainer.topActionsBar.buttons = [];
  }

  ngOnInit() {
  }

}
